/**
 * @version 1.0.1
 * @author yangf
 * @createTime:2021-10-08,
 * @updateTime:2021-10-08
 * @copyright thunisoft fd
 */

import tabPageMinix from '../../tabPageMinix';
import process from '@/components/app/processEcharts/index.vue';

export default {
    name: 'spajtj',
    mixins: [tabPageMinix],
    components: {process},
    data() {
        return {
            // 审判案件统计表格
            tableSpajtj: [],
            // 全国海事法院审判案件
            tableQghsfyspaj: [],
            ayData: []
        };
    },
    created() {
        this.init();
    },
    methods: {
        init() {
            const _searchData = this.$parent.searchData;
            const _this = this;
            window.fdGlobal.ajax({
                method: window.fdConfig.methodGet,
                url: window.fdConfig.url.szsjtj.countForSpajtj,
                params: _searchData
            })
                .then((res) => {
                    _this.ayData = res.data.ayData;
                    _this.tableSpajtj = res.data.tableSpajtj;
                    _this.tableQghsfyspaj = [
                        {
                            'title': '大连海事法院',
                            'name': '辽宁',
                            'xs': res.data.tableQghsfyspaj['大连海事法院'] ? res.data.tableQghsfyspaj['大连海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['大连海事法院'] ? res.data.tableQghsfyspaj['大连海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['大连海事法院'] ? res.data.tableQghsfyspaj['大连海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['大连海事法院'] ? res.data.tableQghsfyspaj['大连海事法院'].wjajs : 0
                        },
                        {
                            'title': '天津海事法院',
                            'name': '天津',
                            'xs': res.data.tableQghsfyspaj['天津海事法院'] ? res.data.tableQghsfyspaj['天津海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['天津海事法院'] ? res.data.tableQghsfyspaj['天津海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['天津海事法院'] ? res.data.tableQghsfyspaj['天津海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['天津海事法院'] ? res.data.tableQghsfyspaj['天津海事法院'].wjajs : 0
                        },
                        {
                            'title': '青岛海事法院',
                            'name': '山东',
                            'xs': res.data.tableQghsfyspaj['青岛海事法院'] ? res.data.tableQghsfyspaj['青岛海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['青岛海事法院'] ? res.data.tableQghsfyspaj['青岛海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['青岛海事法院'] ? res.data.tableQghsfyspaj['青岛海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['青岛海事法院'] ? res.data.tableQghsfyspaj['青岛海事法院'].wjajs : 0
                        },
                        {
                            'title': '南京海事法院',
                            'name': '江苏',
                            'xs': res.data.tableQghsfyspaj['南京海事法院'] ? res.data.tableQghsfyspaj['南京海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['南京海事法院'] ? res.data.tableQghsfyspaj['南京海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['南京海事法院'] ? res.data.tableQghsfyspaj['南京海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['南京海事法院'] ? res.data.tableQghsfyspaj['南京海事法院'].wjajs : 0
                        },
                        {
                            'title': '上海海事法院',
                            'name': '上海',
                            'xs': res.data.tableQghsfyspaj['上海海事法院'] ? res.data.tableQghsfyspaj['上海海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['上海海事法院'] ? res.data.tableQghsfyspaj['上海海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['上海海事法院'] ? res.data.tableQghsfyspaj['上海海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['上海海事法院'] ? res.data.tableQghsfyspaj['上海海事法院'].wjajs : 0
                        },
                        {
                            'title': '武汉海事法院',
                            'name': '湖北',
                            'xs': res.data.tableQghsfyspaj['武汉海事法院'] ? res.data.tableQghsfyspaj['武汉海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['武汉海事法院'] ? res.data.tableQghsfyspaj['武汉海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['武汉海事法院'] ? res.data.tableQghsfyspaj['武汉海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['武汉海事法院'] ? res.data.tableQghsfyspaj['武汉海事法院'].wjajs : 0
                        },
                        {
                            'title': '宁波海事法院',
                            'name': '浙江',
                            'xs': res.data.tableQghsfyspaj['宁波海事法院'] ? res.data.tableQghsfyspaj['宁波海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['宁波海事法院'] ? res.data.tableQghsfyspaj['宁波海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['宁波海事法院'] ? res.data.tableQghsfyspaj['宁波海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['宁波海事法院'] ? res.data.tableQghsfyspaj['宁波海事法院'].wjajs : 0
                        },
                        {
                            'title': '厦门海事法院',
                            'name': '福建',
                            'xs': res.data.tableQghsfyspaj['厦门海事法院'] ? res.data.tableQghsfyspaj['厦门海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['厦门海事法院'] ? res.data.tableQghsfyspaj['厦门海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['厦门海事法院'] ? res.data.tableQghsfyspaj['厦门海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['厦门海事法院'] ? res.data.tableQghsfyspaj['厦门海事法院'].wjajs : 0
                        },
                        {
                            'title': '广州海事法院',
                            'name': '广东',
                            'xs': res.data.tableQghsfyspaj['广州海事法院'] ? res.data.tableQghsfyspaj['广州海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['广州海事法院'] ? res.data.tableQghsfyspaj['广州海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['广州海事法院'] ? res.data.tableQghsfyspaj['广州海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['广州海事法院'] ? res.data.tableQghsfyspaj['广州海事法院'].wjajs : 0
                        },
                        {
                            'title': '北海海事法院',
                            'name': '广西',
                            'xs': res.data.tableQghsfyspaj['北海海事法院'] ? res.data.tableQghsfyspaj['北海海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['北海海事法院'] ? res.data.tableQghsfyspaj['北海海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['北海海事法院'] ? res.data.tableQghsfyspaj['北海海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['北海海事法院'] ? res.data.tableQghsfyspaj['北海海事法院'].wjajs : 0
                        },
                        {
                            'title': '海口海事法院',
                            'name': '海南',
                            'xs': res.data.tableQghsfyspaj['海口海事法院'] ? res.data.tableQghsfyspaj['海口海事法院'].xsajs : 0,
                            'jc': res.data.tableQghsfyspaj['海口海事法院'] ? res.data.tableQghsfyspaj['海口海事法院'].jcajs : 0,
                            'yj': res.data.tableQghsfyspaj['海口海事法院'] ? res.data.tableQghsfyspaj['海口海事法院'].yjajs : 0,
                            'wj': res.data.tableQghsfyspaj['海口海事法院'] ? res.data.tableQghsfyspaj['海口海事法院'].wjajs : 0
                        }
                    ];
                });
        }
    }
};

